import {MMQueryOptions} from 'lionheartland';


export class SODeleteInvoice {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
